
export const BidayuhAgriList = [

    {
        img_src: "https://66.media.tumblr.com/aba8012cae41614cc76791d0c85c004f/2759c82d08adf493-ab/s1280x1920/eb2d494feab1eb81eadb4313f2c4a304456d756a.png",
        alt: 'basong',
        name: "Basong @ Kurit",
        description: "The function of Basong (as known by the people of Bidayuh in Padawan) or Kurit (by the Bidayuh people of Serian) is the same as Umpuk Padi which is to store the harvested paddy. Both of these tools are made from the same material as well. The only difference is, Basong does not have wood at the edge.",
    },
  
    {
      img_src:"https://66.media.tumblr.com/357839dcbba1fab95837660d69ba7f5c/2759c82d08adf493-23/s540x810/84b6ddf5d1f5ffb68d0895dbab34ccca49a7207b.png",
      alt: 'eyeg',
      name: "Eyeg",
      description: "Eyeg (as known by the Bidayuh people of Serian) is used to sift rice grains. Paddy rice will be spread onto the Eyeg and through the process of sifting, the seeds are separated from the stalks.",

  
    },
  
    {
      img_src: "https://66.media.tumblr.com/db9e63acd268c180d9bc7a4dca98b119/3424aa2fad16c0e9-16/s540x810/567a0767669995fe8f8a35f72c0254ed34e24c42.png",
      alt: 'kiser-padi',
      name: "Kisar Padi",
      description: "Kiser Padi is used to grind paddy into a smooth texture. The tool requires a lot of energy in order to shake the big wood. It took a lot of time and effort to refine the paddy",

    },
  
    {
      img_src: "https://66.media.tumblr.com/d8cedff2dc76f5f870002c4f1fbf1672/2759c82d08adf493-59/s1280x1920/cacfdff81e3752d2fc1c0c436191eae83b4c9184.png",
      alt: 'pejek',
      name: "Pejek",
      description: "Pejek is used to store paddy after a harvest. It is made by a long bamboo",

    },
    {
      img_src: "https://66.media.tumblr.com/b9e958f5f607a002678deb95fcd57eaf/2759c82d08adf493-76/s1280x1920/348ff7b39222f0dc3db8b5b3eede7b42f4d8e6a5.png",
      alt: 'risong',
      name: "Risong",
      description:"Risong or as the other community called it, Lesong Batu, is used to beat the paddy rice. The container to do so is called Lesong. They were both made by the 'Kayu Belian' in which why it is quite heavy.",

    },
  
    {

      img_src: "https://66.media.tumblr.com/fd78198babac99ec363b3385dfe664ea/2759c82d08adf493-dd/s1280x1920/288d7fedb347a0eee2f690fb9630f3ddd95cf5d8.png",
      alt:'umpuk-pedi',
      name: "Umpuk Pedi",
      description: "Umpuk Pedi is a great container for storing harvested paddy. Its frame is made by rattan ",

    },
];

export const BidayuhHandiList = [
    {
      img_src: "https://66.media.tumblr.com/f694b77b52d8441a5c6743eb3e2c2136/cb3608b1dd70eca3-fe/s400x600/639468cffd63dddf05946b4bbba5f14813df0f92.png",
      alt: 'bakul-tabacco',
      name: "Bakul Tabacco",
      description: "An interesting thing about Bakul Tabacco is the fact that is was made by yellow orchid fibres. Because of it is light-weight, it is easy for people to store item and carry them around. ",
    },
  
    {
      img_src: "https://66.media.tumblr.com/dbc86ec3d96c0183090429bd7ad3ba30/cb3608b1dd70eca3-20/s1280x1920/6220d8e42d14e71c362b1288801d0906f40fb9bf.png",
      alt: 'jumuok',
      name: "Jumuok",
      description: "Jumuok is a basket made by rattan. It is used to store paddy seeds during the Niligar Piin ceremony.",

    },
  
    {
      img_src: "https://66.media.tumblr.com/7fe37e7b50e0a59e12150c395e0daa54/cb3608b1dd70eca3-8c/s540x810/a44f97764bea03502da3d16ec0b3822ab57ac87a.png",
      alt: 'kasah',
      name: "Kasah",
      description: "Kasah or Tikar Rotan is a mat made from woven ratten with dried bark. The Bidayuh community uses this mat as a tool to dry out paddy.",
    },
  
  
  
    {
      img_src: "https://66.media.tumblr.com/608126c72b42f23ee1370a4e80671189/cb3608b1dd70eca3-a3/s1280x1920/e268e3364ada054050a477e7c2155bf42b411dde.png",
      alt: 'kilimben',
      name: "Kilimben",
      description: "Kilimben is an agricultural tool. However, it is interesting to note that is crafted from woven Nipah leaves with its frame made of rattan. Some uses it as a tool for sloping salted fish. ",
    },
  
    {
      img_src: "https://66.media.tumblr.com/c4dd5bab2c3d532c6bc6582fc033e96a/cb3608b1dd70eca3-28/s1280x1920/30068a61a6911183a0ae8c096d8f20b0d874a727.png",
      alt: 'lipok',
      name: "Lipok",
      description: "Lipok is made by the same wood derived from kayaks and in the Lipok has old bamboos.",
    },
  
    {
      img_src: "https://66.media.tumblr.com/51fe69f4311d72d311d4b30a7720166b/cb3608b1dd70eca3-0a/s1280x1920/dd6874d2e27f80d3a9fc4cb81dd4f5891b63e63e.png",
      alt: 'tajau',
      name: "Tajau",
      description: "Tajau is a jar made from pottery. Most Tajaus has its own carvings and patterns. Mainly used as a storage, Tajau can also be used to make tufts in which the wine will be stored for a period of time.",
    },
  
    {
      img_src: "https://66.media.tumblr.com/6916f2f376a987c6bd58f6504e23c39c/cb3608b1dd70eca3-52/s1280x1920/ae4f3432f62bd141b0ace6c44a069fa4fc679d87.png",
      alt: 'tampi',
      name: "Tampi",
      description: "Tampi or Tampik is made out of Nipah leaves with its frame made from rattan. It is used to sift flour or grains.",
    },
  
    {
      img_src: "https://66.media.tumblr.com/af565df899b978aa6e1e054fdcd5af65/cb3608b1dd70eca3-59/s1280x1920/f7bec4ba95019e44c20f5254dad54cafbde19274.png",
      alt: 'sireung-tumbok',
      name: "Sireung & Tumbok ",
      description: "Sireung and Tumbok are women's dance equipments made out of rattan and Nipah leaves. Without any of both, a woman's costume would be incomplete. The dance in which these items are need is called Langgie Pengindap. During the dance, Tumbok will be placed over the shoulders and Sireung will be used as a hat.",
    },
  
];
  
export const BidayuhMusicList = [
    {
      img_src: "https://66.media.tumblr.com/7ff708a0566e65ab0d56cd7ca4c3a7b2/tumblr_pxno3mb1Ks1yvw4bpo2_540.jpg",
      alt: 'trak',
      name: "T'rak",
      description: "T'rak is a musical instrument made out of metal. ",
    },
  
];
  
export const BidayuhOthersList = [
    {
      img_src: "https://66.media.tumblr.com/f968e4746952295f3cfe79330e43c240/tumblr_pxno47Qg0m1yvw4bpo1_540.jpg",
      alt: 'abuh',
      name: "Abuh",
      description: "Abuh is an old kitchen or a kitchenware that is used for cooking. A piece of metal or iron is placed underneath the Abuh to prevenet it from burning when fire is lit. Unlike modern stove, fire is ignited using firewood.",
   
    },
  
    {
      img_src: "https://66.media.tumblr.com/7dfaaebe6b34aeaa4c650392c446c8c6/tumblr_pxno47Qg0m1yvw4bpo3_250.jpg",
      alt: "Atip-Tebu",
      name: "Atip Tebu",
      description: "By literal definition, Atip Tebu means sugarcane clippers. It is made entirely out of wood and is used to squeezes the sugarcane.",
      
    },
  
    {
      
      img_src: "https://66.media.tumblr.com/be5e319f7783685cd0e3b91b1b1636ef/tumblr_pxno47Qg0m1yvw4bpo4_500.jpg",
      alt: "Empara",
      name: "Empara",
      description: "Empara is a like shelf for people to place items in order. An interesting fact about Empara is that it does not require nails to hold the wood structure up in place but instead was tied up with rattan. ",
      
    },
  
    {
      
      img_src: "https://66.media.tumblr.com/209a686d4f5511f504e738987a198133/2759c82d08adf493-1c/s1280x1920/1e7eab9c0dfc0821fdf5357d1e1f6a00d7362d03.png" ,
      alt: "Sungko",
      name: "Sungko",
      description: "The fishing equipments are part of Bidayuh artefacts. They are made out of rattan or bamboo and comes in various shape and patterns.",
      
  
    },
  
    {
      
      img_src:"https://66.media.tumblr.com/e0914f8f4f136230e9c2aa727014d916/2759c82d08adf493-ba/s1280x1920/6a69faf6909fd1cfca6b3ad323f0f8924306094f.png",
      alt:"Suwang",
      name:"Suwang",
      description: "The fishing equipments are part of Bidayuh artefacts. They are made out of rattan or bamboo and comes in various shape and patterns.",
      
    },
  
    {
      
      img_src:"https://66.media.tumblr.com/79f034c8f18b4a9ddcd47b29b497ab4c/2759c82d08adf493-9e/s1280x1920/03d78de95670c0f4eaf643433d859775c7ee81e1.png",
      alt:"Sakui",
      name:"Sakui",
      description: "The fishing equipments are part of Bidayuh artefacts. They are made out of rattan or bamboo and comes in various shape and patterns.",
      
    },
  
    {
      
      img_src:"https://66.media.tumblr.com/54708ae4e1fb190ba4198c4ea4bbe1cf/2759c82d08adf493-59/s1280x1920/95e4dedff5670bf1575930343657eb1b125f6878.png",
      alt:"Silintek",
      name:"Silintek",
      description: "The fishing equipments are part of Bidayuh artefacts. They are made out of rattan or bamboo and comes in various shape and patterns.",
      
    },
];